(() => {
  const root = document.documentElement;
  const keys = { ArrowLeft: -1, ArrowUp: -1, ArrowRight: 1, ArrowDown: 1 };
  document.addEventListener('pointerdown', () => root.setAttribute('data-fp-pointer', ''), true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Tab') root.removeAttribute('data-fp-pointer');
    if (event.altKey || event.ctrlKey || event.metaKey || event.defaultPrevented) return;
    if (!(event.key in keys) && event.key !== 'Home' && event.key !== 'End') return;
    const group = event.target.closest?.('[data-fp-arrows]');
    if (!group) return;
    const selector = group.dataset.fpArrows || 'button,a[href]';
    const items = [...group.querySelectorAll(selector)].filter(item => !item.disabled && item.getClientRects().length && !item.closest('[hidden],[inert]'));
    const index = items.indexOf(event.target.closest(selector));
    if (index < 0) return;
    event.preventDefault();
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (index + keys[event.key] + items.length) % items.length;
    root.removeAttribute('data-fp-pointer');
    items[next].focus();
  });
  const drawer = document.getElementById('cartSidebar');
  if (!drawer) return;
  const trigger = () => document.querySelector('[data-toggle="cartSidebar"]');
  const focusables = () => [...drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea,[tabindex]:not([tabindex="-1"])')].filter(item => item.getClientRects().length && !item.closest('[hidden]'));
  let returnTo = null, open = false;
  new MutationObserver(() => {
    const isOpen = drawer.classList.contains('is-open');
    if (isOpen && !open) {
      open = true;
      returnTo = drawer.contains(document.activeElement) || document.activeElement === document.body ? trigger() : document.activeElement;
      requestAnimationFrame(() => { if (!drawer.contains(document.activeElement)) (drawer.querySelector('[data-close]') || focusables()[0])?.focus({ preventScroll: true }); });
    } else if (!isOpen && open) {
      open = false;
      const target = returnTo?.isConnected ? returnTo : trigger();
      setTimeout(() => target?.focus({ preventScroll: true }), 60);
    }
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
    const items = focusables();
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (!drawer.contains(document.activeElement)) { event.preventDefault(); first.focus(); }
    else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
})();
